$(document).ready(function() {
  
  
  // Help center page
  
  if(~window.location.href.indexOf('/pages/help-center#')) {
    
    setTimeout(function() {
      var neededTitle = window.location.hash.replace('#', '');
      goToHelpCenterHeader(neededTitle);
    }, 1);
    
    $(".help-center-page .faq-accordion dd .content p").each(function() {
      
      if($(this).find('strong').length) {
        var strongText = $(this).find('strong').text();
        var pText = $(this).text();
        if(strongText == pText) $(this).css('margin-bottom', '0');
      }
      
      if($(this).text() == 'PRFO Sports' && $(this).next().text() == '333 Principale') {
        $(this).css('margin-bottom', '0');
        $(this).next().css('margin-bottom', '0');
        $(this).next().next().css('margin-bottom', '0');
        $(this).next().next().next().css('margin-bottom', '0');
      }
      
      if(~$(this).find('a').text().indexOf('Canada Post return')) $(this).find('a').addClass('button button--primary ');
    });
    
  }
  $('footer a').on('click', function() {
    if($(this).attr('href').indexOf('/help-center#')) goToHelpCenterHeader($(this).attr('href').split('/help-center#')[1]);
  });


  function goToHelpCenterHeader(neededTitle) {
    var title = neededTitle.split('_')[0];
    var subtitle = neededTitle.split('_')[1];
    if(subtitle) subtitle = decodeURIComponent(subtitle.replace(/[-]+/g, ' ')).toLowerCase();
    if($('.faq-template-section').is(":visible")) {
      var headerHeight = 0;
      var scrollingElement = false;
      if($('.header-sticky-wrapper').length) headerHeight = $('.header-sticky-wrapper').height();

      $('.faq-template-section .faq-accordion .accordion__button').each(function() {
        // var pointTitle = $(this).text().trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        var pointTitle = $(this).attr('data-anchor');

        if(pointTitle == title) {
          scrollingElement = this;
          if($(this).attr('aria-expanded') != 'true') $(this).trigger('click');


          if(subtitle) {
            var contentBlock = $(this).attr('aria-controls');
            $('#'+contentBlock+' *').each(function() {
              var wording = $(this).text().trim().toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/-$/, '').replace(/^-/, '');
              // console.log('subtitle = '+subtitle+'; wording = '+wording);
              if(wording == subtitle) scrollingElement = this;
            });
          }
        }
        else if($(this).attr('aria-expanded') == 'true') $(this).trigger('click');
      });
      if(scrollingElement) {
        setTimeout(function() {
          $('html, body').animate({
            scrollTop: ($(scrollingElement).offset().top - headerHeight) 
          }, 1000);
        }, 501);
      }
    }
  }
  
  
  // Mobile Dropdown cart
  
  var headerMobile = $('#mobile-header-sticky-wrapper');
  if(headerMobile.length) {
    if(headerMobile.height() > 0) $('#theme-ajax-cart.is-mini-cart').css('max-height', 'calc(100vh - '+headerMobile.height()+'px)');
  }
  
  
  // Privy Header line
  
  if($('#shopify-section-header__top-bar').length) {
    var heightTopbar = parseInt($('#shopify-section-header__top-bar').height());
    var timer = 0;
    var privyHeaderPresent = setInterval(function() {
      timer = timer + 500;
      var privyLine = $('body').find('.privy-pusher.privy-pusher-top');
      if(privyLine.length) {
        clearInterval(privyHeaderPresent);
        $('#shopify-section-header__top-bar').after(privyLine);
        var privyContainer = $('body').find('.privy-tab-container.privy-top');
        if(privyContainer.length) {
          setTimeout(function() {
            privyLine.height(parseInt(privyContainer.height()));
            if(privyLine.height() > 100) privyLine.height(100);
            privyContainer.css('top', heightTopbar+'px');
          }, 200);
          var checkPrivyContainerHeight = setInterval(function() {
            privyContainer = $('body').find('.privy-tab-container.privy-top');
            if(privyContainer.height() == 0) {
              privyLine.css('height', 0);
              clearInterval(checkPrivyContainerHeight);
            }
          }, 1000);
        }
      }
      if(timer == 15000) clearInterval(privyHeaderPresent);
    }, 500);
  }
  
  
  // Tabs
  
  $('.product_section .tabs-section .headers .tab').on('click', function() {
    $(this).addClass('active').siblings('.tab').removeClass('active');
    var page = $(this).data('connect');
    $('.product_section .tabs-section .contents .tab-content.'+page).addClass('active').siblings('.tab-content').removeClass('active');
  });
  $('.product_section .tabs-section .contents .tab').on('click', function() {
    $(this).toggleClass('active').siblings('.tab').removeClass('active');
  });
  

  $('.product_section .size-chart-icon a').on('click', function() {
    if($(window).width() >= 992) {
      $('.product_section .tabs-section .headers .tab[data-connect="size-chart"]').trigger('click');
     
      var headHeight = 0;
      if($('.header.sticky--enabled').length) headHeight = $('.header.sticky--enabled').outerHeight();
      $('body, html').animate({scrollTop: ($('.product_section .tabs-section .headers').offset().top - headHeight)}, 600);
    }
    else {
      $('.product_section .tabs-section .contents .tab[data-connect="size-chart"]').trigger('click');
      var headHeight = 0;
      if($('.mobile-header.sticky--enabled').length) headHeight = $('.mobile-header.sticky--enabled').outerHeight();
      $('body, html').animate({scrollTop: ($('.product_section .tabs-section .contents .tab[data-connect="size-chart"]').offset().top - headHeight)}, 900);
    }
    return false;
  });
  
  
  
  /* All brands page */

  $('.page-brands-new .header-custom .to-top').on('click', function() {
    $('html,body').animate({ scrollTop: 0 }, 'slow');
    return false;
  });
  
  $('.page-brands-new .letters-line a').on('click', function() {
    var headerHeight = 0;
    if($('.header.sticky--enabled').length) headerHeight = $('.header.sticky--enabled').outerHeight();
    var id = $(this).attr('href').replace('#', '');
    if($('div[id="'+id+'"]').length) $('html,body').animate({ scrollTop: ($('div[id="'+id+'"]').offset().top - headerHeight) }, 1000);
    return false;
  });
  
//   $(function() {
//  //   $('.page-brands-new .column a').each(function() {
//       let url = $(this).attr('href') + '.js';
//       $.ajax({
//     //    url: 'https://performance-sports.myshopify.com/api/graphql',
//         url: 'https://performance-sports.myshopify.com/api/2021-07/graphql.json',
//         method: 'GET',
//         headers: {
//          'X-Shopify-Storefront-Access-Token': 'unauthenticated_read_product_listings',
//          'Content-Type': 'application/graphql',
//         },
//         data: `query {
//           products(first:10){
//             edges {
//               node {
//                 title
//               }
//             }
//           }
//         }`,
//       })
//       .done(function(data) {
//         console.log(data);
//       })
// //    });
//   });
  
  
  
  /* Loyalty Lion page */
  
  if($('body').hasClass('customers-register') || $('body').hasClass('customers-login')) {
    $('#create-customer input[type="submit"], .login__form input[type="submit"]').on('click', function() {
      $.cookie('registered-from-lion-page', 'yes', { expires: 200, path: '/' });
    });
  }
  
  if($('body').hasClass('customers-register') && window.location.hash.length) {
    var elem = $('.'+window.location.hash.replace('#', ''));
    if(elem.length) {
      var offset = elem.offset().top;
      $([document.documentElement, document.body]).animate({
        scrollTop: (offset - 115)
      }, 2000);
      setTimeout(function() {
        if(offset < elem.offset().top) {
          $([document.documentElement, document.body]).animate({
            scrollTop: (elem.offset().top - 115)
          }, 1000);
        }
      }, 2000);
    }
  }
  
  $('#shopify-section-loyalty-lion-section .rewards-faq .inner .faq .question').on('click', function() {
    $(this).toggleClass('active').siblings('.answer').slideToggle(500);
  });
  
  $('#shopify-section-loyalty-lion-section .rewards-faq > .arrow').on('click', function() {
    $(this).toggleClass('active');
    $('#shopify-section-loyalty-lion-section .rewards-faq .inner').slideToggle(1500);
    if(!$(this).hasClass('active')) $("html, body").animate({ scrollTop: $("#shopify-section-loyalty-lion-section .rewards-faq > h2").offset().top }, 1500);
  });
  
  
  
/* Responsive tables */

  if($('body').hasClass('product') || $('body').hasClass('page')) {
    
    $('.product_section .product-tabs table').each(function() {
      $(this).wrap("<div class='wrapped-overflow' />");
    });
    
    var switched=false;
    var updateTables=function(){
      if(($(window).width()<797)&&!switched) {
        
        $('.product_section .size-chart table').each(function() {
          $(this).wrap("<div class='wrapped-overflow' />");
        });
        
        switched=true;
        $(".template-page .main-content .container table").each(function(i,element){
          $(this).addClass('responsive');
          splitTable($(element));
        });
        return true;
      }
      /*
      else if(switched&&($(window).width()>767)){
        switched=false;
        $("table.responsive").each(function(i,element){
          unsplitTable($(element));
        });
      }};
    */
    }
    updateTables();
//    $(window).bind("resize",updateTables);
    function splitTable(original) {
      original.wrap("<div class='table-wrapper' />");
      var copy=original.clone();
      copy.find("td:not(:first-child), th:not(:first-child)").css("display","none");
      copy.removeClass("responsive");
      original.closest(".table-wrapper").append(copy);
      copy.wrap("<div class='pinned' />");
      original.wrap("<div class='scrollable' />");
    }
    function unsplitTable(original){
      original.closest(".table-wrapper").find(".pinned").remove();
      original.unwrap();original.unwrap();
    }
  }
  
  
  
/* Product page */
  
  if($('body').hasClass('product')) {
    $('.swatch_options .swatch').each(function() {
      var soldOut = true;
      $(this).find('.swatch-element').each(function() {
        if(!$(this).hasClass('soldout')) soldOut = false;
      });
      if(soldOut) $(this).hide();
    });

    if($('.product-gallery__thumbnails').length) {
      if($(window).width() < 799) $('.product-gallery__thumbnails').appendTo($('.product-gallery--content_side'));
      // else if($('.product__information.with-thumbnails').length) $('body').find('.product-gallery__thumbnails').insertAfter($('.product-form-container'));
      else if($('.product__information.with-thumbnails').length) $('body').find('.product-gallery__thumbnails').appendTo($('.product__information'));
    }

    $(window).on('resize', function() {
      setTimeout(function() {
        if($('body').hasClass('product') && $('body').find('.product-gallery__thumbnails').length) {
          if($(window).width() < 799) $('body').find('.product-gallery__thumbnails').appendTo($('.product-gallery--content_side'));
          // else $('body').find('.product-gallery__thumbnails').insertAfter($('.product-form-container'));
          else $('body').find('.product-gallery__thumbnails').appendTo($('.product__information'));
        }
      }, 1000);
    });
    
  }

  















  

  
  
  // Mobile Mega menu
  
  if($(window).width() > 798) {
    $('.header__menu-items .mega-menu > .container > .column.additional .mega-menu__linklist > ul').each(function() {
      $(this).unwrap().unwrap().unwrap().appendTo($(this).prev());
    });
  }
  else {
    $('.mobile-menu .mobile-menu-link').on('click', function() {
      if($(this).next('.close-dropdown').length) {
        $(this).next('.close-dropdown').trigger('click');
        // console.log('trigger');
        return false;
      }
    });
    $('.mobile-menu .close-dropdown').on('click', function() {
//      $(this).parent().siblings('.mobile-submenu__list').slideToggle(300);
      if($(this).parent().next('.mobile-menu__submenu').find('.mega-menu > .container > .medium-down--one-half').length) {
        var _this = this;
        setTimeout(function() {
          $(_this).parent().next('.mobile-menu__submenu').find('.mega-menu > .container').masonry();
        }, 100);
      }
//      return false;
    });
  }
  
  
  // Desktop Mega menu
  
  /*
  if($(window).width() > 798) {
    desktopMegaMenu();
      setTimeout(function() { desktopMegaMenu(); }, 2000);
      setTimeout(function() { desktopMegaMenu(); }, 4000);
      setTimeout(function() { desktopMegaMenu(); }, 6000);
      setTimeout(function() { desktopMegaMenu(); }, 8000);
      setTimeout(function() { desktopMegaMenu(); }, 10000);
  }
  function desktopMegaMenu() {
    $('.navbar-item.header__item.has-mega-menu').each(function() {
      var navBarTop = this.getBoundingClientRect().top;
      var navBarHeight = $(this).height();
      var windowHeight = $(window).height();
      $(this).find('.mega-menu').css('max-height', (windowHeight + pageYOffset - navBarTop - navBarHeight));
    });
  }
  */
  
  
  // Footer menus collapsing
  
  if($(window).width() <= 798) {
    $('.footer__heading').on('click', function() {
      $(this).toggleClass('opened');
      $(this).siblings('ul, p, #badge-ribbon').slideToggle(500);
    });
  }
  
  
  // Size Guide taken from Google Sheets
  
  /*
  if($('body.page').length && $('.page__content iframe[src*="docs.google.com/spreadsheets"]').length) {
    $('.page__content iframe[src*="docs.google.com/spreadsheets"]').each(function() {
 //     console.log('iframe.contentWindow.document.body.scrollHeight = '+this.contentWindow.document.body.scrollHeight);
 //     this.style.height = this.contentWindow.document.body.scrollHeight + 'px';
 //     this.style.width = "100%";
      var iframeSrc = $(this).attr('src');
      var iframeContent = false;
      var _this = this;
      $.ajax({
        url: iframeSrc,
        method: 'GET',
        dataType: 'HTML'
      }).always(function(data) {
  //      console.log('data', data);
        var iframe = $(data).find('#sheets-viewport iframe');
        if(iframe.length) {
          iframeSrc = iframe.attr('src');
          $.ajax({
            url: iframeSrc,
            method: 'GET'
          }).always(function(data) {
            console.log('second data', data);
            iframeContent = $(data).find('#sheets-viewport');
            $(_this).after(iframeContent);
    //        $(_this).remove();
          });
        }
        else {
          var replacedData = data.replace("(window.enterCoreJsErrorDialog ? enterCoreJsErrorDialog() : (window.location.href = 'https:\\/\\/support.google.com\\/accounts\\/answer\\/32050'))", "");
          replacedData = replacedData.replace('/static/spreadsheets2/client/js/', '//docs.google.com\/static\/spreadsheets2\/client\/js\/');
          replacedData = replacedData.replace("sendBeacon('\\/spreadsheets", "sendBeacon('\/\/docs.google.com\/spreadsheets");
          replacedData = replacedData.replace('/static/spreadsheets2/', '//docs.google.com\/static\/spreadsheets2\/');
          replacedData = replacedData.replace("'/static/spreadsheets2/", "'//docs.google.com\/static\/spreadsheets2\/");
          console.log('replacedData', replacedData);
          $('.page__content').closest('div').after(replacedData);
    //    $(_this).remove();
        }
      });
    });
  }
  */
  
});



/* Link Obfuscation & Cloaking */

document.addEventListener("DOMContentLoaded", function(event) {
	var elems = document.querySelectorAll("[data-atc]");
	for (var i = 0; i < elems.length; i++) {
		elems[i].addEventListener('click', customClickCurrentPage, false);
		elems[i].addEventListener('contextmenu', customClickNewWindow, false);
	}
});



/* Redirection after Register/Login  */


$(document).ready(function() {
  var redirectLogin = '/account';
  var redirectRegister = '/account';

  if($('form[action="/account/login"]').length){
    $('form[action="/account/login"]').append('<input type="hidden" name="checkout_url" value="' + redirectLogin + '">');
  }

  if($('input[value="create_customer"]').length){
    $('input[value="create_customer"]').closest('form').append('<input type="hidden" name="return_to" value="' + redirectRegister + '">');
    if(document.referrer.indexOf('/challenge') !== -1 && !$('.form-message--error').length) {
      window.location.href = redirectRegister;
    }
  }

  if($('.shopify-challenge__container').length){
    if(document.referrer.indexOf('/register') !== -1) {
      $('.shopify-challenge__container > form').append('<input type="hidden" name="return_to" value="' + redirectRegister + '">');
    }
  }
});





// Functions

function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

var customClickCurrentPage = function(event) {
  var attribute = this.getAttribute("data-atc");  
  var isTargetBlank = this.getAttribute("target");
  if(isTargetBlank == '_blank') isTargetBlank = true;
  else isTargetBlank = false;
  if(event.ctrlKey || isTargetBlank) {                   
    var newWindow = window.open(attribute, '_blank');                    
    newWindow.focus();               
  } else {                    
    document.location.href= attribute;
  }
};

var customClickNewWindow = function(event) {
  var attribute = this.getAttribute("data-atc");               
  if(event.ctrlKey) {
    var newWindow = window.open(attribute, '_blank');                    
    newWindow.focus();               
  } else {      
    window.open(attribute, '_blank');	
  }
}

